import React from 'react';

export default function WscNotesTab({ items, theme, isDark }) {
  const withNotes = items.filter(i => i.notes && i.notes.trim());

  if (!withNotes.length) {
    return (
      <div style={{ fontSize: 13, color: theme.textSecondary, padding: '24px 0', textAlign: 'center' }}>
        No notes yet
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {withNotes.map(item => (
        <div key={item.id} style={{
          padding: '8px 10px', borderRadius: 6,
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid ' + theme.border,
        }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: theme.text, marginBottom: 3 }}>
            {item.doc}
          </div>
          <div style={{ fontSize: 12, color: theme.textSecondary, lineHeight: 1.4 }}>
            {item.notes}
          </div>
        </div>
      ))}
    </div>
  );
}
